import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	Image,
	TextAlignment,
	AspectRatioContainer,
	CTA,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { Bonus } from '@esportal/portal-service';
import { BonusHelper, vwDataRedirect } from '../../../../helpers/BonuesHelper';
import { PortalContext } from '../../../../context/PortalContext';
import { formatOwnership } from '../../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';

export const BonusPopup: React.FC<{
	bonusPopupData: Bonus;
	vwBankLayer: () => void;
}> = ({ bonusPopupData, vwBankLayer }) => {
	const { navigationService, userInteractionService, portalService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();

	const bonusVehicle = bonusPopupData?.frame
		? portalService.getVehicleByFrame(bonusPopupData.frame).getValue()
		: undefined;

	useEffect(() => {
		trackingManager.trackClubVWLayerLoad(
			{ contentId: `Bonus Popup Layer: ${bonusPopupData.title}` },
			{ vehicle: formatOwnership(bonusVehicle ? [bonusVehicle] : undefined) },
		);
	}, []);

	const isvwBankUrl = /(bedesa-vw\.ceca\.es|volkswagenbank\.es|vwfs\.es)/.test(bonusPopupData.cta.bonusPageId);

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="16:9">
				<Image
					src={bonusPopupData.imageUrlLayer}
					alt="Imagen bono"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text
					appearance={TokenTextAppearance.headline300}
					textAlign={TextAlignment.center}
					color={TokenTextColor.primary}
				>
					{BonusHelper.buildLiteralMarkdownElement(
						bonusPopupData.titleLayer ? bonusPopupData.titleLayer : bonusPopupData.title,
					)}
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.bigcopy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						{BonusHelper.buildLiteralMarkdownElement(bonusPopupData.description)}
					</Text>
				</Container>

				{bonusPopupData.mode && (
					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.dynamic0130,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
							¿Cómo puedes utilizarlo?
						</Text>
						<Text
							appearance={TokenTextAppearance.bigcopy100}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							{BonusHelper.buildLiteralMarkdownElement(bonusPopupData.mode)}
						</Text>
					</Container>
				)}

				{bonusPopupData.cta.bonusPageId && bonusPopupData.cta.text && (
					<Container
						padding={{
							top: ContainerPadding.dynamic0130,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<CTA
							tag="button"
							aria-label="CTA bonus redirect"
							size="large"
							emphasis="primary"
							onClick={() => {
								trackingManager.trackClubVWButtonClick(
									`Bonus Popup Layer: ${bonusPopupData.title}`,
									{
										contentId: `Bonus Popup Layer: ${bonusPopupData.title}`,
									},
									{ vehicle: formatOwnership(bonusVehicle ? [bonusVehicle] : undefined) },
								);

								if (isvwBankUrl) {
									vwBankLayer();
								} else {
									vwDataRedirect(bonusPopupData, navigationService, userInteractionService);
								}
							}}
						>
							<Text> {bonusPopupData.cta.text}</Text>
						</CTA>
					</Container>
				)}

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.tertiary}
					>
						{BonusHelper.buildLiteralMarkdownElement(bonusPopupData.legalText)}
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
